'use strict';

export default function shuffle() {
  return function shuffle(array) {
    const copy = angular.copy(array);

    for (let i = copy.length - 1; i > 0; i -= 1) {
      let j = Math.floor(Math.random() * (i + 1));
      let temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }

    return copy;
  };
}



// WEBPACK FOOTER //
// ./app/src/services/shuffle.service.js